import classnames from 'classnames';
import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import { FC, useRef } from 'react';

import type { Placement } from '../Popover/ErrorsPopover';
import { ErrorsPopover } from '../Popover/ErrorsPopover';

type Props = {
  id: string;
  e2e: string;
  placement: Placement;
  className?: string;
  isInitiallyOpened?: boolean;
};

export const IconWithPopover: FC<Props> = ({ id, e2e, placement, className, isInitiallyOpened = false }) => {
  const infoIconRef = useRef<HTMLElement>(null);

  return (
    <WithToggle isInitiallyOn={isInitiallyOpened}>
      {({ isOn, toggle }) => (
        <>
          <i
            ref={infoIconRef}
            className={classnames('px-0 icon icon-sm text-danger clickable', className)}
            data-e2e={e2e}
            id={id}
            onClick={toggle}
          >
            block
          </i>

          <ErrorsPopover target={infoIconRef} placement={placement} color="danger" isOpened={isOn} onToggle={toggle} />
        </>
      )}
    </WithToggle>
  );
};
